import { useMap } from "react-leaflet";
import { useState, useEffect } from "react";
import { Circle, CircleMarker } from "react-leaflet";
import L from "leaflet";

/**
 * A button that centers the map on the user's current location
 * and displays the location as a marker
 */
export default function LocationButton({ onLocationFound }) {
  const map = useMap();
  const [locating, setLocating] = useState(false);
  const [userLocation, setUserLocation] = useState(null);

  const handleLocate = () => {
    if (!navigator.geolocation) {
      alert("Geolocation is not supported by your browser");
      return;
    }

    setLocating(true);

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude, accuracy } = position.coords;
        const location = { lat: latitude, lon: longitude, accuracy };
        
        setUserLocation(location);
        map.setView([latitude, longitude], 16, {
          animate: true,
          duration: 1
        });
        
        if (onLocationFound) {
          onLocationFound(location);
        }
        
        setLocating(false);
      },
      (err) => {
        console.error("Geolocation error:", err);
        alert("Unable to get your location");
        setLocating(false);
      },
      {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0
      }
    );
  };

  return (
    <>
      <div style={{ position: 'absolute', top: '75px', left: '10px', zIndex: 1000 }}>
        <div className="leaflet-control leaflet-bar">
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              handleLocate();
            }}
            className="leaflet-control-locate"
            title={locating ? "Locating..." : "Show my location"}
            aria-label="Show my location"
            style={{
              width: '30px',
              height: '30px',
              fontSize: '20px',
              fontWeight: '900',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              textDecoration: 'none',
              color: locating ? '#999' : '#000',
              cursor: locating ? 'wait' : 'pointer',
              WebkitFontSmoothing: 'antialiased',
              MozOsxFontSmoothing: 'grayscale',
              WebkitTextStroke: '0.5px currentColor',
              paddingBottom: '2px'
            }}
          >
            {locating ? '⟳' : '⌖'}
          </a>
        </div>
      </div>
      
      {userLocation && (
        <>
          <CircleMarker
            center={[userLocation.lat, userLocation.lon]}
            radius={5}
            pathOptions={{
              fillColor: '#2196F3',
              fillOpacity: 1,
              color: 'white',
              weight: 2
            }}
          />
          <Circle
            center={[userLocation.lat, userLocation.lon]}
            radius={userLocation.accuracy || 50}
            pathOptions={{
              fillColor: '#2196F3',
              fillOpacity: 0.08,
              color: '#2196F3',
              weight: 1,
              opacity: 0.2
            }}
          />
        </>
      )}
    </>
  );
}
